<template>
  <div :class="$style.base">
    <div :class="$style.timeSlots">
      <div
        v-for="timeslot in timeSlots"
        :key="timeslot"
        :class="$style.timeSlot"
        v-test="'time-slot'"
      >
        <BaseText>{{ timeslot }}</BaseText>
      </div>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  timeSlots: string[];
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  gap: $spacing;
  max-height: 100%;
  position: relative;
  align-items: center;
}
.timeSlots {
  display: flex;
  gap: $spacing;
  padding: 2 * $spacing $spacing;
  margin: auto;
  flex-wrap: wrap;
}

.timeSlot {
  display: flex;
  padding: 0.5 * $spacing $spacing;
  align-items: center;
  justify-content: space-evenly;
  min-width: 70px;
  background-color: var(--color-bg);
  border: 1px solid var(--color-border-input);
  border-radius: $radius;
}
</style>
